module.exports = __webpack_public_path__ + "static/img/gpt43.5dd18665.png";